import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BodegaServices } from 'src/app/services/bodegaServices';
import { CatalogServices } from 'src/app/services/catalogServices';
import { UserServices } from 'src/app/services/userServices';
import { ConfigUtils } from 'src/app/utils/configUtils';
import { StringUtils } from 'src/app/utils/stringUtils';

@Component({
  selector: 'app-read-qr',
  templateUrl: './read-qr.page.html',
  styleUrls: ['./read-qr.page.scss'],
})
export class ReadQrPage implements OnInit {
  bodegas:any[]=[];
  ocultarUbicacion:boolean=false;
  bodegaSeleccionada:any;
  
  @Input()
  valor:string;
  
  @Input()
  label:string;
  
  @Input()
  requiereCambioBodega:string;

  @Input()
  placeholder:string;

  @Input()
  tipo:string; //lote o ubicacion
  
  @Output() valorChange = new EventEmitter();
  @Output() valorClear = new EventEmitter();
  @Output() onError = new EventEmitter();
  @Output() codBodegaSeleccionadaChange = new EventEmitter<string>();
  
  catalogUbicaciones: any[]=[];
  errorUbicacion: string=null;
  mostrarQr: boolean=true;

  constructor(private catalogService:CatalogServices, private bodegaService:BodegaServices) { 
    this.catalogService.onCacheCatalogUpdated().subscribe(catalogName=>{
      if(catalogName=='ubicaciones'){
        this.setCatalogoUbicaciones();
      }
    });
  }

  ngOnInit() {
    if(this.tipo=='ubicacion'){
      this.setCatalogoUbicaciones();
      if(this.requiereCambioBodega)
        this.setCatalogoBodega();
    }
    if(UserServices.codBodegaPorDefecto && this.requiereCambioBodega)
      this.bodegaSeleccionada={name:UserServices.codBodegaPorDefecto};
  }
  onBodegaChange(bodegaItem){
    //console.log(bodegaItem);
    if(bodegaItem && bodegaItem.name){
      const codBodega=bodegaItem.name;
      //console.log(codBodega);
      this.ocultarUbicacion=!this.bodegaTieneUbicaciones(codBodega);
      //console.log(this.ocultarUbicacion);
      this.codBodegaSeleccionadaChange.emit(codBodega);
    }
  }
  onBodegaBorrada(){
    this.clearQr();
  }
  setCatalogoBodega(){
    this.bodegas=this.bodegaService.getListadoBodegas();
  }
  setCatalogoUbicaciones(){
    this.catalogUbicaciones=[];
    let me=this.catalogService.getCatalogByName('ubicaciones');
    if(me && me.Error){
      console.log('Error: catalogo bodegas '+me.Error);
    }else{
      this.catalogUbicaciones=me.Ubicaciones;
    }
  }
  validarUbicacion(){
    const ubicacionHasta=this.valor;
    this.errorUbicacion=null;
    if(!this.existeUbicacion(ubicacionHasta)){
      this.errorUbicacion="La ubicación selecccionada no esta registrada en SAP";
      return false;
    }
    return true;
  }
  bodegaTieneUbicaciones(codBodega){
    if(!this.catalogUbicaciones || this.catalogUbicaciones.length==0)
      this.setCatalogoUbicaciones()
    if(this.catalogUbicaciones){
      let ubicaciones=this.catalogUbicaciones.find(u=>u.includes(codBodega));
      if(ubicaciones)
        return true; 
    }
    return false;
  }
  existeUbicacion(ubicacion){
    for(let item of this.catalogUbicaciones){
      if(item==ubicacion)
        return true;
    }
    return false;
  }
  
  qrValChange(e){
    if(e && e.detail){
      let me=e.detail.value;
       //si tiene la url se hace la consulta del servicio web para traer el detalle del QR
      let tokenBusqueda=null;
      switch(this.tipo){
        case 'lote':
          console.log(me);
          tokenBusqueda=ConfigUtils.getUrlFromEndPointName('urlConsultaLoteArticulo');
          /*if(me && me.includes('&')){ 
            //se paso el artículo en el QR
            //Ej: http://app.jbp.com.ec/consultaLote?lote=JB-250520122914&codArticulo=11000092
            var matrix=me.split('&')
            if(matrix.length>0)
              me=matrix[0]
          }*/
          break;
        case 'ubicacion':
          tokenBusqueda=ConfigUtils.getUrlFromEndPointName('urlConsultaUbicacion');
          break;
      }
      console.log(me);
      if(tokenBusqueda && StringUtils.contains(me, tokenBusqueda)){
        this.valor = me.replace(tokenBusqueda,'');
        if(this.tipo=='ubicacion'){
          var codBodega=null;
          if(this.bodegaSeleccionada)
            codBodega=this.bodegaSeleccionada.name;
          else
            codBodega=UserServices.codBodegaPorDefecto;
          if(codBodega){
            this.valor=codBodega+'-'+this.valor;
            this.validarUbicacion();
          }else{
            this.onError.emit('No se ha definido la planta de producción al que pertence el usuario de bodega. Diríjase al final del apartado de configuración y de click en "Cambiar Usuario"!!');
            return;
          }
        }
        this.valorChange.emit(this.valor);
      }
    }
  }
  clearQr(){
    this.valor=null;
    this.valorClear.emit();
  }
}
